import { render, staticRenderFns } from "./PSupportAttachments.vue?vue&type=template&id=51fdd7d3"
import script from "./PSupportAttachments.vue?vue&type=script&lang=js"
export * from "./PSupportAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports